import { render, staticRenderFns } from "./myExplainList.vue?vue&type=template&id=2030496a&scoped=true"
import script from "./myExplainList.vue?vue&type=script&lang=js"
export * from "./myExplainList.vue?vue&type=script&lang=js"
import style0 from "./myExplainList.vue?vue&type=style&index=0&id=2030496a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2030496a",
  null
  
)

export default component.exports